<template>
  <div class="__footer">
    <Button :label="$t('Cancel')" class="mr-md" vClosePopup />
    <Button :label="$t('Apply')" color="primary" @click="$emit('submit')" />
  </div>
</template>

<script>
import Button from '@/components/uikit/CButton';

const messages = {
  en: {
    Apply: 'Apply',
    Cancel: 'Cancel',
  },
  ja: {
    Apply: '適用',
    Cancel: 'キャンセル',
  },
};
export default {
  name: 'Footer',
  i18n: { messages: messages },
  components: { Button },
};
</script>

<style lang="scss" scoped>
.__footer {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: $padding-sm;
  border-top: 1px solid $border-color;

  & > button {
    &:first-child {
      margin-right: $margin-lg;
    }
  }
}
</style>
